module.exports = __webpack_public_path__ + "img/Sprogreformation_Wergeland_tegnet_av_Christian_Olsen.63a16ae5.jpg";